import { render, staticRenderFns } from "./chips.vue?vue&type=template&id=a89f5300&scoped=true&"
import script from "./chips.vue?vue&type=script&lang=js&"
export * from "./chips.vue?vue&type=script&lang=js&"
import style0 from "./chips.vue?vue&type=style&index=0&id=a89f5300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89f5300",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VContainer,VDivider,VRow})
